<template>
  <mdb-container v-if="periodList.length > 0" class="gp-has-header text-left" fluid>
    <mdb-card class="mb-3">
      <mdb-card-header class="secondary-color"><h5>Metrics</h5>
        <span class="small"><i>As Of {{ metrics.asOfDate }} </i></span>
      </mdb-card-header>
      <mdb-card-body>
        <select id="access-type" v-model="selectedPeriod" class="browser-default custom-select">
          <option v-for="(p,i) in periodList" :key="i" :value="p.id">{{ p.text }}</option>
        </select>
      </mdb-card-body>
    </mdb-card>
    <mdb-tabs :active="0" :links="tabLinks" :transition-duration="0.5" card
              class="mb-5"
              tabs
              transition-style="linear"
    >
      <div slot="Groups">
        <mdb-row class="d-flex align-self-stretch">
          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="success"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="users"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('newGroups')" class="ml-4 mt-4 mb-2 font-weight-bold">
                    {{ currentPeriod.newGroups.toLocaleString() }}</h5>
                  <p class="font-small grey-text">New Groups</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="secondary"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="users"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('publicGroups')" class="ml-4 mt-4 mb-2 font-weight-bold">
                    {{ currentPeriod.publicGroups.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Public Groups</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="warning"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="users"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('privateGroups')" class="ml-4 mt-4 mb-2 font-weight-bold">
                    {{ currentPeriod.privateGroups.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Private Groups</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="primary"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="users"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('totalGroups')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.totalGroups.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Total Groups</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="success"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="calendar"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('completedEvents')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.completedEvents.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Completed Events</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="danger"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="calendar"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 v-if="currentPeriod.hasOwnProperty('canceledEvents')"
                      class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.canceledEvents.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Canceled Events</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col v-if="currentPeriod.plannedEvents > 0" class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="warning"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="calendar"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('plannedEvents')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.plannedEvents.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Planned Events</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="mb-4" md="6" xl="12">
            <mdb-card v-if="currentPeriod.mostActiveEvents">
              <mdb-card-header class="text-center secondary-color">
                <h4>Most Popular Events</h4>
                <h6>(By # of Reservations)</h6>
              </mdb-card-header>
              <mdb-card-body>
                <mdb-list-group>
                  <mdb-list-group-item v-for="(e,i) in currentPeriod.mostActiveEvents" v-bind:key="i">
                    {{ e.name }}
                    <mdb-badge>{{ e.value }}</mdb-badge>
                  </mdb-list-group-item>
                </mdb-list-group>

              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>

      </div>

      <div slot="Users">
        <mdb-row>
          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="success" floating size="lg" tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="user"
                    />
                  </mdb-btn>
                </mdb-col>
                <mdb-col class=" text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('newUsers')"
                       class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.newUsers.toLocaleString() }}</h5>
                  <p class="font-small grey-text">New Users</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="primary" floating size="lg" tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="eye"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class=" text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('distinctUsers')"
                       class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.distinctUsers.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Active Users</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>

          </mdb-col>

          <mdb-col v-if="currentPeriod.disabledUsers" class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="warning" floating size="lg" tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="user"
                    />
                  </mdb-btn>
                </mdb-col>
                <mdb-col class=" text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('disabledUsers')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.disabledUsers.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Disabled Users</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col v-if="currentPeriod.deletedUsers" class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="danger" floating size="lg" tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="user"
                    />
                  </mdb-btn>
                </mdb-col>
                <mdb-col class=" text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('deletedUsers')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.deletedUsers.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Deleted Users</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="primary" floating size="lg" tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="user"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class=" text-right pr-5" col="7" md="7" v-if="currentPeriod.userCount">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">{{ currentPeriod.userCount.toLocaleString() }}</h5>
                  <p class="font-small grey-text">Total Users</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>

          </mdb-col>

        </mdb-row>
      </div>

      <div slot="Subscriptions">
        <mdb-row>
          <mdb-col class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 lighten-1"
                    color="light-green"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="dollar-sign"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5  v-if="currentPeriod.hasOwnProperty('stripePayments')"
                    class="ml-4 mt-4 mb-2 font-weight-bold">
                    $ {{ Math.round(currentPeriod.stripePayments).toLocaleString() }}
                  </h5>
                  <p class="font-small grey-text">Stripe Payments
                    <mdb-btn floating tag="a" icon="download" rounded size="sm" @click="stripeDownload"/>
                  </p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

          <mdb-col v-for="(sub,i) in currentPeriod.subscriptions" :key="i" class="mb-4" md="6" xl="3">
            <mdb-card>
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 lighten-1"
                    color="secondary"
                    floating
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="file-invoice-dollar"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">
                    {{ Math.round(sub.value).toLocaleString() }}</h5>
                  <p class="font-small grey-text">{{ sub.name }}</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
          </mdb-col>

        </mdb-row>
      </div>

      <div slot="Map">
        <mdb-vector-map v-if="mapOptions"
                        :legend="legend"
                        :options="mapOptions"
                        :strokeWidth="0.4"
                        fill="#e8f5e9"
                        hover-fill="white"
                        select-fill="rgba(0, 0, 0, 0.3)"
                        stroke="black"
                        @select="selected = $event"
        />
      </div>
    </mdb-tabs>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem,
  mdbRow,
  mdbTabs
} from 'mdbvue';
import mdbVectorMap from "mdbvue-vector-map";
import download from 'js-file-download'

export default {
  name: "metrics",
  display: "Metrics",
  order: 1,
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbIcon,
    mdbCol,
    mdbRow,
    mdbBtn,
    mdbTabs,
    mdbListGroup, mdbListGroupItem, mdbBadge,
    mdbVectorMap
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  watch: {
    selectedPeriod(n) {
      this.currentPeriod = this.metrics[n]
      this.setMapOptions()
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/admin/metrics").then(
      (details) => {
        this.metrics = details.data
        this.doSetup()
        this.setMapOptions()
      },
      (error) => {
        this.$notify.error({message: "Error getting data."})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  data() {
    return {
      metrics: null,
      currentPeriod: null,
      periodList: [],
      selectedPeriod: null,
      selected: null,
      tabLinks: [{text: 'Groups'}, {text: 'Map'}, {text: 'Users'}, {text: 'Subscriptions'}],
      mapOptions: {},
      legend: {
        title: "Groups by Country",
        colorCode: [
          {
            color: "#e8f5e9",
            text: "No Groups"
          },
          {
            color: "#66bb6a",
            text: "1 or more groups"
          }
        ]
      }
    }
  },
  methods: {
    doSetup() {
      for (const period in this.metrics) {
        let periodName = period.replace("_", " ")
        if (periodName != "asOfDate") {
          let cy = new Date().getFullYear();
          let py = cy - 1;
          periodName = periodName.replace("CY", cy)
          periodName = periodName.replace("PY", py)
          let p = {id: period, text: periodName}
          this.periodList.push(p)
          if (period == "Current_Month") {
            this.currentPeriod = this.metrics[period]
            this.selectedPeriod = period
          }
        }
      }
    },
    setMapOptions() {
      this.mapOptions = {}
      if (!this.currentPeriod || !this.currentPeriod.groupsByCountry) return
      for (const i in this.currentPeriod.groupsByCountry) {
        let c = this.currentPeriod.groupsByCountry[i]
        this.mapOptions[c.name] = {
          fill: "#66bb6a",
          tooltip: c.extra
        }
      }
    },
    changePeriod(period) {
      this.currentPeriod = period
    },
    stripeDownload() {

      this.$store.dispatch("setExecuting", true)
      api.getBlob("/admin/stripeDownload?period=" + this.selectedPeriod).then(
        (results) => {
          //let filename = "stripe_payments_" + this.selectedPeriod.toLowerCase() + ".csv"
          let filename = "stripe_payments_" + this.selectedPeriod.toLowerCase() + ".xlsx"
          download(results.data, filename)
        },
        (error) => {
          this.$notify.error({message: "Error getting data. " + error})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }

}
;
</script>
